import initCarousel from '../helpers/carousel';
import ProductItem from '../components/product/ProductItem';

export default class DynamicProductSlider {
  constructor(section) {
    this.el = section.el;
    this.section = section;

    const selectors = {
      productItem: '[data-product-item]',
      productCarousel: '[data-product-carousel]',
      contentCarousel: '[data-content-carousel]',
      prevButton: '.splide__arrow--prev',
      nextButton: '.splide__arrow--next',
      currentCounter: '[data-carousel-counter]',
    };

    this.contentCarousel = this.el.querySelector(selectors.contentCarousel);
    this.productCarousel = this.el.querySelector(selectors.productCarousel);
    this.prevButton = this.el.querySelector(selectors.prevButton);
    this.nextButton = this.el.querySelector(selectors.nextButton);
    this.currentCounter = this.el.querySelector(selectors.currentCounter);

    const productItems = this.el.querySelectorAll(selectors.productItem);
    [...productItems].forEach(productItem => {
      new ProductItem(productItem);
    });

    this._initCarousels();
  }

  _initCarousels() {
    if (!this.productCarousel) {
      return;
    }

    /** Initialize media carousel */
    this.mediaCarousel = initCarousel(
      this.productCarousel,
      {
        type: 'fade',
        perPage: 1,
        perMove: 1,
        gap: '1rem',
        pagination: false,
        arrows: false,
        drag: false,
      },
      true,
    );

    this.nextButton.addEventListener('click', e => {
      this.mediaCarousel.go('+1');
      this._updateCounter();
    });

    this.prevButton.addEventListener('click', e => {
      this.mediaCarousel.go('-1');
      this._updateCounter();
    });

    if (this.mediaCarousel) {
      this.mediaCarousel.on('moved', () => {
        this._updateCounter();
      });
      this._updateCounter();
    }
  }

  _updateCounter() {
    if (this.currentCounter && this.mediaCarousel) {
      const currentSlide = this.mediaCarousel.index + 1;
      const totalSlides = this.mediaCarousel.length;

      this.currentCounter.textContent = currentSlide;

      /** Handle button disabled states */
      if (this.prevButton && this.nextButton) {
        /** Remove existing disabled attributes */
        this.prevButton.removeAttribute('disabled');
        this.nextButton.removeAttribute('disabled');

        /** Add disabled attribute if at first slide */
        if (currentSlide === 1) {
          this.prevButton.setAttribute('disabled', '');
        }

        /** Add disabled attribute if at last slide */
        if (currentSlide === totalSlides) {
          this.nextButton.setAttribute('disabled', '');
        }
      }
    }
  }
}
